// extracted by mini-css-extract-plugin
export default {"header":"PageSectionHeader_header__aTkns"};